
/**
 * 工作流-结束节点
 * zxw
 * 创建时间 2026-04-03
 */

import CNF from '../../incs/Config';
import { winHeight } from '../../incs/FunHelper';
import { convertVariableTags, formattedContent } from '../../components/MultifunctionalInput';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Select,
    Typography,
    Input,
    Tooltip,
} from 'antd';
import {
    InfoCircleOutlined,
} from '@ant-design/icons';
import ContentEditable from "react-contenteditable";

import NodeVariableModel from './NodeVariableModel.js';

const { Text, Paragraph } = Typography;

const EndNodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [outputMode, setOutputMode] = useState('Text');

    const [wrapLabel, setWrapLabel] = useState('');         // 包裹标签  

    const [outputVariable, setOutputVariable] = useState('');                       // 输出模版
    const [outputVariableIsFocused, setOutputVariableIsFocused] = useState(false);  // 系统提示词是否聚焦
    const [openOutputVariable, setOpenOutputVariable] = useState(false);            // 打开输出变量

    const cancel = () => {
        setOpen(false);
    }

    useEffect(() => {
        setOpen(props.open);
        // 初始化
        if (props.node.data?.outputMode) {
            setOutputMode(props.node.data?.outputMode);
        } else {
            setOutputMode('Text');
        }
        if (props.node.data?.output.wrapLabel) {
            setWrapLabel(props.node.data?.output.wrapLabel);
        } else {
            setWrapLabel('');
        }
        if (props.node.data?.output.result) {
            setOutputVariable(props.node.data?.output.result);
        } else {
            setOutputVariable('');
        }
    }, [props]);

    // 更新输出模式
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            output: {
                mode: outputMode,
            },
        });
    }, [outputMode]);

    // 更新包裹标签
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            output: {
                wrapLabel: wrapLabel,
            },
        });
    }, [wrapLabel]);

    // 更新输出模版
    useEffect(() => {
        props.node.setData({
            ...props.node.data,
            output: {
                result: convertVariableTags(outputVariable),
            },
        });
    }, [outputVariable]);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {props.node.data?.title}
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Text>输出模式</Text><Text type='danger'>*</Text>
                    <Select
                        placeholder='请选择模型'
                        style={{ width: '100%' }}
                        options={[
                            {
                                label: 'Text',
                                title: 'Text',
                            },
                            {
                                label: 'Json',
                                title: 'Json',
                            },
                        ]}
                        value={outputMode}
                        onChange={(value) => {
                            setOutputMode(value);
                            props.node.setData({
                                ...props.node.data,
                                output: {
                                    mode: value,
                                },
                            });
                        }}
                    />
                </Paragraph>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <Paragraph>
                    <Space><Text>包裹标签</Text><Tooltip title={`形如：<chart-pie-percent>，约束正则表达式：^<[a-z-]*>$`}><InfoCircleOutlined style={{ color: props.colorBasePlaceholder }} /></Tooltip></Space>
                    <Input
                        placeholder='请输入标签'
                        value={wrapLabel}
                        onChange={(e) => {
                            const raw = e.target.value;
                            // 移除非法字符
                            const filtered = raw
                                .toLowerCase()
                                .replace(/[^<>a-z-]/g, '');
                            setWrapLabel(filtered);
                        }}
                    />
                </Paragraph>
                <Paragraph style={{ marginBottom: 0 }}>
                    <Text>输出模版<Text type='danger'>*</Text></Text>
                    <div style={{
                        position: 'relative',
                        border: `1px solid ${outputVariableIsFocused ? props.colorPrimary : '#d9d9d9'}`,
                        padding: '10px 10px 2px 10px',
                        borderRadius: 6,
                        transition: 'all 0.2s',
                        boxShadow: `0 0 0 ${outputVariableIsFocused ? '1.5px' : '0'} ${props.colorPrimaryBg}`,
                    }}>
                        <div
                            style={{
                                height: 100,
                                scrollbarColor: '#d9d9d9 transparent',
                                scrollbarWidth: 'thin',
                                overflowY: 'auto',
                            }}
                            onFocus={() => setOutputVariableIsFocused(true)}
                            onBlur={() => {
                                setOutputVariableIsFocused(false);
                            }}
                        >
                            <ContentEditable
                                html={formattedContent(outputVariable, props.graph)}                // 渲染带格式的 HTML
                                onChange={(e) => {
                                    setOutputVariable(e.target.value ? e.target.value : '');
                                }}
                                tagName='div'
                                style={{ minHeight: '40px', outline: 'none' }}
                                onKeyDown={(e) => {
                                    // 只处理单字符按键（key 长度为 1 且不是修饰键）
                                    if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                                        // 注意：e.key 已经考虑了 Shift，例如 Shift+a 得到 'A'
                                        // 输入“/或者、”弹出变量选项界面
                                        if (e.key === '/' || e.key === '、') {
                                            e.preventDefault();
                                            setOpenOutputVariable(true);
                                        } else {
                                            setOpenOutputVariable(false);
                                        }
                                    }
                                }}
                            />
                            <style>{`
                            .variable-tag {
                                background: #F5F6F8;
                                border-radius: 4px;
                                padding: 2px 6px;
                                margin: 0 4px;
                                color: ${props.colorTextBase};
                                user-select: all;
                                cursor: default;
                                font-size: ${CNF.fontSizeSM}px;
                            }
                            .variable-name {
                                color: ${props.colorPrimary};
                            }
                        `}</style>
                        </div>
                        <Text style={{ fontSize: CNF.fontSizeXS, color: CNF.basePlaceholderColor }}>输入“/”插入变量</Text>
                        {
                            openOutputVariable ? <NodeVariableModel
                                graph={props.graph}
                                node={props.node}
                                value={outputVariable}
                                setValue={setOutputVariable}
                                cancel={setOpenOutputVariable}
                            /> : ''
                        }
                    </div>
                </Paragraph>
            </Modal>
        </ConfigProvider >
    );
}

export default EndNodeEntity;